// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Breadcrumb_breadcrumb__1H_tJ","canClick":"Breadcrumb_canClick__2ouLj"};